import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import red_circle from "../../../../assets/images/icons/red-circle.png";
import "./MyTask.scss";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const MyTask = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const rootRef=useRef(null);
  const pendingTasks=useRef(new Set());

  const taskClose = async (task_id) => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");

    const formData = new FormData();
    formData.append("task_id", task_id);
    formData.append("type", "status_check");
    formData.append("value", "closed");
    formData.append("action_type", "salsa_task");
    if (!task_id || pendingTasks.current.has(task_id)) return;
    pendingTasks.current.add(task_id);
    try {
      const resp=await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=changetask&status=1`,formData);
      if(resp.data?.status===false) { toast.error(resp.data.message || 'Task update failed'); return; }
      await taskDetails();
      toast('Request sent; task list refreshed. Please check the displayed status.');
    } catch(error) { toast.error('Task update could not be confirmed. Please refresh before retrying.'); }
    finally { pendingTasks.current.delete(task_id); }

  };

  const taskDetails = async () => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const user_id = localStorage.getItem("session_user_id");

    const formData = new FormData();
    formData.append("user_id", user_id);

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getTaskNew&status=1`,
        formData
      )
      .then((resp) => {
        setData(resp.data);

      });
  };

  useEffect(() => {
    taskDetails();
  }, []);

  useEffect(()=>{
    const root=rootRef.current;if(!root)return;
    root.querySelectorAll('td img').forEach(image=>{image.src=red_circle;});
    root.querySelectorAll('.attendsmn a,.check_status').forEach(button=>{
      button.removeAttribute('onclick');
      if(button.matches('a')) {button.className='btn btn_primary';button.removeAttribute('style');}
    });
    const handler=(event)=>{
      const button=event.target.closest('.attendsmn a,.check_status');if(!button||!root.contains(button))return;
      const id=button.closest('tr')?.querySelector('.check_admin')?.getAttribute('data-id');
      if(!id)return;event.preventDefault();
      if(button.matches('.check_status'))taskClose(id);
      else navigate(button.textContent.trim()==='View Notes'?`/Home/profile/viewNotes/${id}`:`/Home/profile/processList/${id}`);
    };
    root.addEventListener('click',handler);return()=>root.removeEventListener('click',handler);
  },[data]);

  return (
    <div className="task_section" ref={rootRef}>
      <div className="container-fluid">
        <div className="user_detail">
          <div className="task_title">
            <h2>My TASKS</h2>
          </div>
        </div>
        <div className="task_inner">
          <div className="task_table">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Task Name</th>
                    <th>Responsible Teacher</th>
                    <th>Student</th>
                    <th>Repeat</th>
                    <th>Notes</th>
                    <th>Status</th>
                    <th>Deadline Date</th>
                    <th>Warning Date</th>
                    <th>Telephone Detail</th>
                    <th>Quality check</th>
                    <th>Completed By Teacher</th>
                    <th>Quality status</th>
                    <th>CEO status</th>
                    <th>Quality Reject count</th>
                    <th>CEO Reject count</th>
                    <th>Close Task?</th>
                    <th>Task Process</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody
                  className="table-group-divider"
                  dangerouslySetInnerHTML={{ __html: data }}
                ></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTask;
